import "vite/modulepreload-polyfill";
import { createRoot } from "react-dom/client";
import ContactWidget from "./Components/ContactWidget.jsx";

const container = document.getElementById("contact-widget-container");
const configContainer = document.getElementById("contact-widget-config");
let configuration = "";
if (configContainer) {
  configuration = JSON.parse(configContainer.innerText);
}
if (container) {
  const root = createRoot(container);
  root.render(
    <div className="contact-widget-container">
      <ContactWidget config={configuration} />
    </div>
  );
}
